var DEFAULT_CURRENCY = 'USD';
export function createCurrencyExports(_a) {
    var context = _a.context;
    return {
        getCustomerSelectedCurrency: function () {
            var siteStore = context.siteStore;
            var currencyHeader = siteStore.getCurrencyHeader();
            if (currencyHeader) {
                return currencyHeader;
            }
            var siteCurrency = siteStore.siteCurrency;
            if (siteCurrency) {
                return siteCurrency;
            }
            return DEFAULT_CURRENCY;
        },
    };
}
//# sourceMappingURL=wixcode.currency.js.map